export default __webpack_public_path__ + "static/og-815e57715b31c41e5c15cb6b4556356b.png";